module.exports = __webpack_public_path__ + "img/bannerimg8.48b92b6f.png";